import { render, staticRenderFns } from "./sco.vue?vue&type=template&id=c2969546&"
import script from "./sco.vue?vue&type=script&lang=js&"
export * from "./sco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports